import owlCarousel from '../../components/owl-carousel'
import regular from '../../helpers/regular'

import WOW from '../../../../../node_modules/wow.js/dist/wow.min.js'

const init = () => {
  new regular().init()
  new owlCarousel().carouselCompanies()

  new WOW().init()
}

export default init
